import { combineReducers } from 'redux';

import {
  getUserListFail,
  getUserListRequest,
  getUserListSuccess,
} from '../actions';
import { UserAction } from '../types';
import { User } from '../../../../types/items';
import { ItemList } from '../../../../types/main';
import { Loadable, Reducer } from '../../../types';
import { stripItems } from '../../../../utility/store';

type State = Loadable<ItemList<User>>;
type ReducerOf<T extends keyof State> = Reducer<State, UserAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getUserListRequest.type:
      return state ? stripItems(state) : null;

    case getUserListSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getUserListRequest.type:
      return true;

    case getUserListSuccess.type:
    case getUserListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
});
